import { CheckCircle2 } from 'lucide-react';
import Icon from '@/components/site/Icon';
import Reveal from '@/components/ui/Reveal';
import { SpotlightCard } from '@/components/ui/SpotlightCards';

/** Service cards with image, summary and key points. */
export default function ServiceDetailGrid({ services = [] }) {
  return (
    <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-3">
      {services.map((s, i) => (
        <Reveal key={s.slug || s.title} delay={(i % 3) * 0.06}>
          <SpotlightCard id={s.slug}>
            {s.image && (
              <div className="relative z-10 -mx-6 -mt-8 aspect-[16/10] overflow-hidden">
                <img src={s.image} alt="" loading="lazy" className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105" />
              </div>
            )}
            <div className="relative z-10 flex items-center gap-3">
              <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-lg bg-primary-50 text-primary-600 transition-colors group-hover:bg-primary-600 group-hover:text-white">
                <Icon name={s.icon} className="h-5 w-5" />
              </span>
              <h3 className="text-2xl leading-tight text-ink-950">{s.title}</h3>
            </div>
            <p className="relative z-10 text-sm leading-relaxed text-ink-600">{s.summary}</p>
            {s.pointList?.length > 0 && (
              <ul className="relative z-10 mt-auto space-y-2 border-t border-[var(--app-border)] pt-4">
                {s.pointList.map((p) => (
                  <li key={p} className="flex gap-2 text-sm text-ink-700">
                    <CheckCircle2 className="mt-0.5 h-4 w-4 shrink-0 text-primary-500" aria-hidden="true" />
                    {p}
                  </li>
                ))}
              </ul>
            )}
          </SpotlightCard>
        </Reveal>
      ))}
    </div>
  );
}
